"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
const theme_1 = require("../../styles/theme");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const lodash_1 = __importDefault(require("lodash"));
const MID_MOBILE_BREAKPOINT = 450;
const CommonDialog = Props => {
    const { description, type, question, title = 'Are you sure?', confirmationText = 'Delete', cancellationText = 'Cancel', dialogContainerStyle, isMobileView, showSubmit = true, onOkPress, onCancelPress, translateFunction = text => text, } = Props;
    const classes = useStyles({ isMobileView, showSubmit });
    const handleSubmit = (e) => {
        e.stopPropagation();
        onOkPress && onOkPress();
    };
    const onCancel = (e) => {
        e.stopPropagation();
        onCancelPress && onCancelPress();
    };
    return (react_1.default.createElement(core_1.Dialog, { open: true, onClose: undefined, transitionDuration: { exit: 0, enter: 100 }, maxWidth: "xl", className: classes.mainDialog, PaperProps: { style: dialogContainerStyle }, BackdropComponent: () => react_1.default.createElement(core_1.Box, { className: classes.backdrop, onClick: e => e.stopPropagation() }), onClick: e => e.stopPropagation() },
        react_1.default.createElement(core_1.Box, { className: classes.body },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: (type === 'confirmation' ? pro_regular_svg_icons_1.faCircleQuestion : pro_regular_svg_icons_1.faCircleExclamation), className: `${classes.icon} ${type === 'error' && classes.error}` }),
            react_1.default.createElement(core_1.Box, null,
                react_1.default.createElement(core_1.Typography, { className: classes.header }, translateFunction(title)),
                lodash_1.default.size(question) > 0 && react_1.default.createElement(core_1.Typography, { className: classes.question }, translateFunction(question)),
                translateFunction(description))),
        react_1.default.createElement(core_1.Box, { className: classes.footerRow },
            react_1.default.createElement(core_1.Button, { variant: "contained", onClick: onCancel, className: `${classes.button} ${classes.cancel}`, disableElevation: true }, translateFunction(cancellationText)),
            showSubmit && (react_1.default.createElement(core_1.Button, { variant: "contained", color: "primary", disableElevation: true, onClick: handleSubmit, style: styles.saveButton, className: classes.button }, translateFunction(confirmationText))))));
};
const styles = {
    saveButton: {
        color: theme_1.colors.white,
        fontWeight: 500,
    },
};
const useStyles = (0, core_1.makeStyles)((theme) => ({
    mainDialog: (props) => ({
        '& .MuiPaper-root': props.isMobileView
            ? {
                width: '100%',
                height: '100%',
                maxHeight: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                margin: 0,
                borderRadius: 0,
            }
            : {
                width: 570,
                height: 'auto',
                boxShadow: `0px 2px 10px 0px ${theme_1.colors.black10}`,
                borderRadius: 4,
            },
    }),
    body: props => ({
        padding: '30px 28px 34px',
        display: 'flex',
        flexDirection: props.isMobileView ? 'column' : 'row',
        gap: props.isMobileView ? 12 : 18,
        height: props.isMobileView ? '100%' : 'auto',
    }),
    header: {
        fontSize: 20,
        color: theme_1.colors.black0,
        fontWeight: 500,
        lineHeight: 'normal',
        marginBottom: 3,
    },
    content: {
        paddingTop: 0,
        paddingBottom: 20,
        overflow: 'hidden',
    },
    label: {
        fontSize: 14,
        fontWeight: 400,
        color: theme_1.colors.black,
        paddingBottom: 26,
        lineHeight: 'normal',
    },
    footerRow: props => ({
        display: 'flex',
        justifyContent: props.isMobileView ? (props.showSubmit ? 'flex-end' : 'center') : 'flex-end',
        gap: 10,
        padding: '10px 25px 12px',
        backgroundColor: theme_1.colors.lotion,
        borderTop: `1px solid ${theme_1.colors.black05}`,
        [theme.breakpoints.down(MID_MOBILE_BREAKPOINT)]: {
            justifyContent: 'space-between',
        },
    }),
    button: props => ({
        width: props.isMobileView ? (props.showSubmit ? 166.5 : '100%') : 99.5,
        height: 32,
        borderRadius: 2,
        fontSize: 14,
        fontWeight: 400,
        lineHeight: 'normal',
        textTransform: 'none',
    }),
    cancel: {
        color: theme_1.colors.black0,
        backgroundColor: theme_1.colors.whisperGray,
    },
    discardButton: {
        fontSize: 13,
        color: theme_1.colors.white,
        fontWeight: 500,
        borderRadius: 2,
        height: 32,
    },
    backdrop: {
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        backgroundColor: theme_1.colors.black35,
    },
    icon: {
        width: 50,
        height: 50,
        color: theme.palette.primary.main,
    },
    question: {
        fontSize: 15,
        fontWeight: 400,
        lineHeight: 'normal',
        fontFamily: 'Roboto',
        color: theme_1.colors.semiTransparentBlack,
    },
    error: {
        color: theme_1.colors.dangerFontColor,
    },
}));
exports.default = CommonDialog;
//# sourceMappingURL=CommonDialog.js.map